import { useMutation } from '@tanstack/react-query';
import { ClinicalNoteApi } from '../../../apis/ClinicalNoteApi/ClinicalNoteApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { ClinicalNoteType } from '../ClinicalNote';

export interface ISendClinicalNotesToAssistantVariables {
    patientId: string;
    language: string;
}

export function useSendClinicalNotesToAssistant(noteType: ClinicalNoteType, _i18nPrefix: string) {
    return useMutation<
        { assistantName: string; assistantEmail: string },
        AppMedError,
        ISendClinicalNotesToAssistantVariables
    >({
        mutationKey: [QueryKeys.clinicalNotes, noteType, 'sendToAssistant'],
        mutationFn: async ({ patientId, language }) => {
            return await ClinicalNoteApi.sendClinicalNotesToAssistant(patientId, noteType, language);
        },
    });
}
